import type { EmailStatus } from '@/shared/types'

const MAP: Record<EmailStatus, { color: string; title: string }> = {
  deliverable: { color: 'var(--color-success)', title: 'Verifierad' },
  risky: { color: 'var(--color-warning)', title: 'Riskabel' },
  undeliverable: { color: 'var(--color-danger)', title: 'Studsad' },
  unknown: { color: 'var(--color-ink-300)', title: 'Okänd' },
}

interface Props {
  status?: EmailStatus | null
}

export default function EmailDot({ status }: Props) {
  // Fall back to 'unknown' for any value outside the known set, so an
  // unexpected status can never crash the row.
  const m = MAP[status || 'unknown'] ?? MAP.unknown
  return (
    <span
      className="inline-block w-2 h-2 rounded-full shrink-0 mr-1"
      title={m.title}
      style={{ background: m.color }}
    />
  )
}
